<template>
  <div v-if="categories.length" class="pt-2">
    <h2 class="gamma container text-center mb-2">
      Suosituimmat kategoriat
    </h2>
    <div class="md:container md:px-container pt-3 px-4 pb-2 flex overflow-x-auto lg:grid lg:grid-cols-8 gap-4 md:gap-6">
      <NuxtLink
        v-for="category in categories"
        :key="category.path"
        :to="category.path"
        class="no-underline text-pine-950 text-center duration-200 hover:scale-105 text-sm md:text-base"
      >
        <span class="flex-col flex items-center w-28 xl:w-32 gap-2 xl:gap-4">
          <picture v-if="category.image?.url" class="flex items-center justify-center size-24">
            <img
              :src="lexasImage(category.image.url, 200)"
              :alt="category.image.altText || 'Kategoria kuva'"
              loading="lazy"
              aria-hidden="true"
              width="200"
              height="200"
            >
          </picture>
        </span>
        <span class="font-semibold"> {{ category.name }} </span>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { lexasImage } from '~/helpers/lexasImage'
import { useLexas } from '~/composables/useLexas'

const { getPopularCategories } = useLexas()
const categories = await getPopularCategories()
</script>
